import { HeaderWidgetMapper } from 'mapper/HeaderWidgetMapper';
import { ImageWidgetMapper } from 'mapper/ImageWidgetMapper';
import { PageItemMapper } from 'mapper/PageItemMapper';
import { QuestionCASMapper } from 'mapper/QuestionCASMapper';
import { QuestionCheckboxMapper } from 'mapper/QuestionCheckboxMapper';
import { QuestionCommentBoxMapper } from 'mapper/QuestionCommentBoxMapper';
import { QuestionConsentMapper } from 'mapper/QuestionConsentMapper';
import { QuestionDemographicMapper } from 'mapper/QuestionDemographicMapper';
import { QuestionFormMapper } from 'mapper/QuestionFormMapper';
import { QuestionOpinionMapper } from 'mapper/QuestionOpinionMapper';
import { QuestionRadioMapper } from 'mapper/QuestionRadioMapper';
import { TextWidgetMapper } from 'mapper/TextWidgetMapper';

import { categoryMapper } from './categoryMapper';
import { customQuestionOptionMapper } from './customQuestionOptionMapper';
import { staticResourceMapper } from './staticResourceMapper';

export const pageItemMapper = new PageItemMapper([
  new QuestionDemographicMapper(customQuestionOptionMapper),
  new QuestionOpinionMapper(categoryMapper),
  new QuestionCommentBoxMapper(),
  new QuestionFormMapper(customQuestionOptionMapper),
  new QuestionCheckboxMapper(customQuestionOptionMapper),
  new QuestionConsentMapper(),
  new QuestionRadioMapper(customQuestionOptionMapper),
  new QuestionCASMapper(),
  new QuestionDemographicMapper(customQuestionOptionMapper),
  new TextWidgetMapper(),
  new ImageWidgetMapper(staticResourceMapper),
  new HeaderWidgetMapper(),
]);
